import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Breadcrumbs, Card, CardContent, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { getSaitamaReportOverview, setCurrentPage } from "actions";
import * as C from "components";
import * as V from "styles/variables";
import CalendarRangePicTreeSaitama from "components/Calendar/CalendarRangePicTreeSaitama";
import ReportStatsSaitama from "components/PicTree/Home/ReportStatsSaitama";
import ChartPictreeReportTrendSaitama from "components/Charts/ChartPictreeReportTrendSaitama";
import { PicTreeTableReport } from "components/Table/PicTreeTableReport";

const useStyles = makeStyles((theme) => ({
  breadcrumbs: { marginTop: 16, minHeight: 30 },
  section: { marginTop: theme.spacing(1) },
  noData: { display: "flex", justifyContent: "center", alignItems: "center", minHeight: 280 },
}));

const PicTreeReportSummarySaitama = ({ setCurrentPage, dateRange, reportOverview, getSaitamaReportOverview }) => {
  const classes = useStyles();
  useEffect(() => { setCurrentPage(window.location.pathname); }, [setCurrentPage]);
  useEffect(() => { getSaitamaReportOverview(); }, [dateRange, getSaitamaReportOverview]);
  const trend = reportOverview.reportTrend || [];
  const loading = reportOverview.status === "loading";
  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid container direction="row" justifyContent="space-between" style={{ marginTop: -16, marginBottom: 8 }}>
          <Grid item><Breadcrumbs separator="›" className={classes.breadcrumbs}><Typography>さいたま市</Typography><Typography>報告</Typography><Typography>概要</Typography></Breadcrumbs></Grid>
          <Grid item><CalendarRangePicTreeSaitama /></Grid>
        </Grid>
        <Grid container className={classes.section}><Grid item xs={12}><Card><CardContent><ReportStatsSaitama data={reportOverview} /></CardContent></Card></Grid></Grid>
        <Grid container className={classes.section}><Grid item xs={12}>
          {loading ? <div className={classes.noData}><img width="40" src="/static/images/loader-bar.gif" alt="loading" /></div> : trend.length ? <ChartPictreeReportTrendSaitama reportTrend={trend} tagOrder={reportOverview.tagOrder || []} /> : <div className={classes.noData}><Chip label="No Data" style={{ color: V.textColor, backgroundColor: V.placeholderColor }} /></div>}
        </Grid></Grid>
        <Grid container className={classes.section}><Grid item xs={12}><PicTreeTableReport reportTrend={trend} pageTopLoader={loading} /></Grid></Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({ dateRange: state.pictreeSaitama.dateRange, reportOverview: state.pictreeSaitama.reportOverview });
const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (value) => dispatch(setCurrentPage(value)),
  getSaitamaReportOverview: () => dispatch(getSaitamaReportOverview()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PicTreeReportSummarySaitama);
